import { useParams } from "react-router-dom";

const RegisterCompleted = () => {
  const { status } = useParams<{ status: string }>();

  return (
    <div style={{ margin: 'auto', textAlign: 'center', marginTop: '2%' }}>
      {status === "new" && (
        <h1>
          ההרשמה והתשלום בוצעו בהצלחה!
          <br />
          ברגעים אלה נשלחה לכתובת הדואר האלקטרוני שהזנת הודעת אישור
        </h1>
      )}

      {status === "already" && (
        <h1>
          הנך כבר רשום לאימון,
          <br />
          בתום ההרשמה נשלחה הודעת אישור הרשמה לכתובת הדואר האלקטרוני שהזנת
          <br />
          במידה ואינך מוצא את ההודעה ניתן ליצור קשר עם המדריך לשליחה מחדש
        </h1>
      )}

      {status === "error" && (
        <h1 style={{ color: "#d32f2f" }}>
          התשלום בוצע אך אירעה שגיאה בשמירת פרטי ההרשמה.
          <br />
          אנא צור קשר עם המדריך או מנהל המערכת להשלמת הרישום באופן ידני.
        </h1>
      )}

      <br />
      <p style={{ fontSize: "1.2rem", color: "#666" }}>ניתן לסגור חלון זה כעת<br />תודה</p>
    </div>
  );
};

export default RegisterCompleted;